import Common from '../Common';

export type TimeZones = TimeZone[]

export interface TimeZone {
	id: string
	offset: string
	name: string
	cc: string
	offset_time: string
	offset_time_dst: string
}

const Timezone = class extends Common {
	browse = (): CustomResponse<TimeZones> =>
		this.get('/timezone')
}

export default Timezone
